import React from 'react';
import { motion } from 'framer-motion';
import {
    sapModules,
    liveProjectsLearnersSAP,
    liveProjectsBusinessesSAP,
    businessBenefitsSAP,
    recentProjectsSAP,
    trainingOfferingsSAP,
    trainingModulesSAP,
    whyChooseUsSAP
} from '../../data/expertiseData'; // Import SAP data

// Icons (Consider using a library like react-icons)
const SapModuleIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"></path></svg>
);

const CheckCircleIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);

const BriefcaseIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"></path></svg>
);

const UserGroupIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"></path></svg>
);

const CheckIconBig = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);

const CheckIconGreen = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
);

const OfficeBuildingIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"></path></svg>
);

function SapExpertise() {

    const sectionVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const gridContainerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
    };

    const gridItemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

  return (
    <section id="sap-services" className="py-20 bg-gradient-to-b from-blue-50 via-gray-50 to-gray-50 overflow-hidden border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
            className="text-center mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
        >
          <span className="text-primary font-semibold tracking-wider uppercase">Our SAP Expertise</span>
          <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">Comprehensive SAP Solutions</h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in multiple SAP modules, offering comprehensive solutions tailored to your business needs
          </p>
        </motion.div>

        {/* SAP Module Grid - Use imported sapModules */}
        <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20"
            variants={gridContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
        >
          {sapModules.map((module, index) => (
            <motion.div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-primary/10 transition-shadow p-6 h-full"
                variants={gridItemVariants}
             >
              <div className="flex items-center mb-4">
                <div className="mr-3 bg-primary/10 p-3 rounded-lg text-primary">
                  <SapModuleIcon />
                </div>
                <h3 className="text-xl font-bold text-gray-800">{module.title}</h3>
              </div>
              <ul className="space-y-2 mt-4">
                {module.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <span className="text-primary mt-1 mr-2 flex-shrink-0"><CheckCircleIcon /></span>
                    <span className="text-gray-700 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        {/* Live Projects & Training Section Wrapper */}
        <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
            >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4 text-gray-900">Live SAP Projects for Training & Business Solutions</h2>
            <p className="text-gray-700 max-w-4xl mx-auto">
              At EcoPeak ForceSAP IT Solution Pvt Ltd, we provide live SAP projects for both professionals looking to gain hands-on experience and businesses seeking real-time SAP solutions.
            </p>
          </div>

          <motion.div
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12"
            variants={gridContainerVariants}
           >
            {/* Card for Learners - Use imported liveProjectsLearnersSAP */}
            <motion.div className="bg-white rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-primary to-blue-700 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                <h3 className="text-xl font-bold text-white">For SAP Learners: Hands-on Live Projects</h3>
              </div>
              <div className="p-6">
                <p className="text-gray-700 mb-4 text-sm">
                    Our Live SAP Training Projects help learners gain practical experience by working on real-world business scenarios. These projects are designed to provide exposure to real-time SAP implementation challenges, cover the full project lifecycle, include SAP best practices, and prepare participants for job interviews.
                </p>
                <div className="mb-4">
                  <h4 className="text-md font-semibold mb-2 text-gray-800">🔹 Who Can Join?</h4>
                  <p className="text-gray-700 text-sm">
                    SAP professionals looking to upskill with hands-on experience, freshers seeking real-world SAP exposure, corporate employees who want to work on SAP projects before implementation
                  </p>
                </div>
                <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                <ul className="space-y-2 mb-6">
                  {liveProjectsLearnersSAP.map((project, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                      <span className="text-gray-700 text-sm">{project}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>

            {/* Card for Businesses - Use imported liveProjectsBusinessesSAP and businessBenefitsSAP */}
            <motion.div className="bg-white rounded-xl overflow-hidden shadow-lg" variants={gridItemVariants}>
              <div className="bg-gradient-to-r from-primary to-blue-700 px-6 py-4 flex items-center">
                <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><BriefcaseIcon /></div>
                <h3 className="text-xl font-bold text-white">For Businesses: Real-Time SAP Implementation</h3>
              </div>
               <div className="p-6">
                 <p className="text-gray-700 mb-4 text-sm">
                     We work with clients to implement SAP solutions that solve real business challenges. Our live SAP projects for businesses include:
                 </p>
                 <h4 className="text-md font-semibold mb-2 text-gray-800">Examples of Live Projects:</h4>
                  <ul className="space-y-2 mb-6">
                   {liveProjectsBusinessesSAP.map((project, idx) => (
                     <li key={idx} className="flex items-start">
                       <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                       <span className="text-gray-700 text-sm">{project}</span>
                     </li>
                   ))}
                 </ul>
                 <div>
                   <h4 className="text-md font-semibold mb-2 text-gray-800">📌 How It Benefits Businesses?</h4>
                    <ul className="space-y-2">
                       {businessBenefitsSAP.map((benefit, idx) => (
                         <li key={idx} className="flex items-start">
                           <span className="text-green-500 mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                           <span className="text-gray-700 text-sm">{benefit}</span>
                         </li>
                       ))}
                     </ul>
                 </div>
               </div>
            </motion.div>
          </motion.div>

          {/* Recent Projects Section - Use imported recentProjectsSAP */}
            <motion.div
                className="bg-white rounded-xl p-6 shadow-lg mt-6"
                variants={gridItemVariants}
             >
                <h3 className="text-xl font-bold mb-4 text-gray-800">Recent Live Projects We Have Delivered:</h3>
                {recentProjectsSAP.map((project, idx) => (
                    <div key={idx} className="flex items-start mb-4 last:mb-0">
                        <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                        <div>
                            <h4 className="font-semibold text-gray-800">{project.title}</h4>
                            <p className="text-gray-600 text-sm">{project.description}</p>
                        </div>
                    </div>
                ))}
            </motion.div>
        </motion.div>

         {/* Training Section - Use imported trainingOfferingsSAP and trainingModulesSAP */}
        <motion.div
            className="mb-16"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            transition={{ delay: 0.3 }}
        >
            <div className="bg-white rounded-xl overflow-hidden shadow-xl">
                <div className="bg-gradient-to-r from-primary to-blue-700 px-6 py-4">
                    <div className="flex items-center">
                        <div className="bg-white/20 p-3 rounded-lg text-white mr-4"><UserGroupIcon /></div>
                        <h3 className="text-2xl font-bold text-white">SAP Training Programs</h3>
                    </div>
                </div>
                <div className="p-8">
                    <p className="text-gray-700 mb-6 text-sm">We provide in-depth SAP training for individuals and organizations, ensuring professionals gain hands-on expertise in SAP technologies.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Offerings:</h4>
                            <ul className="space-y-2">
                                {trainingOfferingsSAP.map((offering, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-primary mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{offering}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">Training Modules We Offer:</h4>
                            <ul className="space-y-2">
                                {trainingModulesSAP.map((mod, idx) => (
                                    <li key={idx} className="flex items-start">
                                        <span className="text-primary mt-1 mr-2 flex-shrink-0"><CheckIconBig /></span>
                                        <span className="text-gray-700 text-sm">{mod}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <p className="text-gray-700 italic text-sm">Our expert trainers provide real-time project-based learning, ensuring participants gain industry-relevant skills.</p>
                </div>
            </div>
        </motion.div>

        {/* Why Choose Us Section - Use imported whyChooseUsSAP */}
        <motion.div
            className="bg-white rounded-xl p-8 shadow-lg"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={sectionVariants}
            transition={{ delay: 0.1 }}
        >
          <div className="flex items-center mb-6">
            <div className="bg-primary/10 p-3 rounded-lg text-primary mr-4"><OfficeBuildingIcon /></div>
            <h3 className="text-2xl font-bold text-gray-800">Why Choose EcoPeak ForceSAP IT Solution Pvt Ltd?</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {whyChooseUsSAP.map((reason, idx) => (
                <div key={idx} className="flex items-start">
                    <span className="text-green-500 mt-1 mr-3 flex-shrink-0"><CheckIconGreen /></span>
                    <span className="text-gray-700 text-sm">{reason}</span>
                </div>
            ))}
          </div>
          <p className="mt-6 text-gray-700 text-sm">We are committed to delivering high-quality SAP solutions and training to help businesses and professionals succeed in the digital era.</p>
        </motion.div>

        {/* Call to Action */}
        <motion.div
            className="mt-16 text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
            transition={{ delay: 0.2 }}
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Transform Your Business with SAP?</h3>
          <p className="text-lg text-gray-700 mb-8">Contact us today to discuss your SAP project needs or training requirements.</p>
          <a href="#contact" className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors inline-flex items-center">
            Get in Touch
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default SapExpertise; 